import { AccessProvider } from '../../../contexts/accessProvider.tsx';
import { AlimentsContextProvider } from '../../../contexts/aliments/aliments.tsx';
import { Role } from '../../../models/enums/role.ts';
import AlimentsBody from './body.tsx';
import AlimentsHeader from './header.tsx';

const AdminAliments = () => {
    return (
        <AccessProvider roles={[Role.admin, Role.superAdmin]}>
            <AlimentsContextProvider>
                <AlimentsHeader />
                <AlimentsBody />
            </AlimentsContextProvider>
        </AccessProvider>
    );
};

export default AdminAliments;
